import {Button} from '@ui/buttons/button';
import {DialogTrigger} from '@ui/overlays/dialog/dialog-trigger';
import {InvoiceViewDialog} from './invoice-view-dialog';
import {Trans} from '@ui/i18n/trans';
import {VisibilityIcon} from '@ui/icons/material/Visibility';

interface SubscriptionItemProps {
  subscription: {
    id: number;
    package_id?: number;
    name?: string;
    start?: string;
    end?: string;
    storage?: string | number;
    amount?: string | number;
    status?: number;
  };
}

export function SubscriptionItem({subscription}: SubscriptionItemProps) {
  const isActive = subscription.status === 1;
  const hasInvoice = subscription.id != null;

  const getPackageBadgeStyle = (packageId?: number) => {
    switch (packageId) {
      case 1: return { backgroundColor: 'var(--be-primary)', color: 'var(--be-on-primary)' };
      case 2: return { backgroundColor: '#8b5cf6', color: 'white' };
      case 3: return { backgroundColor: '#10b981', color: 'white' };
      case 4: return { backgroundColor: '#ef4444', color: 'white' };
      case 9: return { backgroundColor: '#f59e0b', color: 'black' };
      default: return { backgroundColor: 'var(--be-background-chip)', color: 'var(--be-text-main)' };
    }
  };

  return (
    <tr key={`subscription_${subscription.id}`} className="hover:bg-muted/30 transition-colors">
      <td className="px-10 py-6">
        {isActive && subscription.package_id ? (
          <span
            className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium"
            style={getPackageBadgeStyle(subscription.package_id)}
          >
            {subscription.name || 'Package'}
          </span>
        ) : (
          <span className="text-sm text-muted">
            {subscription.name || 'Free'}
          </span>
        )}
      </td>
      <td className="px-10 py-6 text-sm text-foreground">
        {subscription.start}
      </td>
      <td className="px-10 py-6 text-sm text-foreground">
        {subscription.end}
      </td>
      <td className="px-10 py-6 text-sm text-foreground">
        {subscription.storage} GB
      </td>
      <td className="px-10 py-6 text-center text-sm font-medium text-foreground">
        £{subscription.amount}
      </td>
      <td className="px-10 py-6">
        {isActive ? (
          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
            Active
          </span>
        ) : (
          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
            Expired
          </span>
        )}
      </td>
      <td className="px-10 py-6">
        {isActive && (
          <DialogTrigger type="modal">
            <Button
              variant="link"
              size="sm"
              className="p-0 h-auto font-normal text-primary hover:text-primary-hover underline"
              startIcon={<VisibilityIcon className="text-base" />}
            >
              <Trans message="View" />
            </Button>
            <InvoiceViewDialog invoiceId={subscription.id} />
          </DialogTrigger>
        )}
      </td>
    </tr>
  );
}
